import { Component } from '@angular/core';
import { UserDTO } from '../../../models/UserDTO.model';
import { PartnersService } from 'src/app/services/partners.service';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { emailValidator } from 'src/app/validators/email.validator';

import { CommonModule } from '@angular/common';
import { FormatPhoneUsDirective } from '../../../directives/format-phone-us.directive';
import { FormatEmailDirective } from '../../../directives/format-email.directive';
@Component({
    selector: 'app-create-partners',
    templateUrl: './create-partners.component.html',
    styleUrls: ['./create-partners.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormatPhoneUsDirective,
        FormatEmailDirective
    ]
})
export class CreatePartnersComponent {
  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]), 
  });

  get emailModel() {
    return this.form.get('email');
  }
  validMail: boolean = false;
  information: string = 'Create Partner';
  partnerName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  states: MasterDataDTO[] = [];
  contactNumber?: string = undefined;
  email: string = '';
  mainContact: string = '';
  mainContactNumber: string = '';
  fieldsCompleted: boolean = false;
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 1,
  };

  alert: Alert = {} as Alert;
  partner: UserDTO = {} as UserDTO;

  constructor(
    private partnerService: PartnersService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService
  ) {}

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Partners);
    this.partnerService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllStatesSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.ErrorMessage();
        this.clearFields();
      }
    );
  }

  checkFields() {
    if (this.partnerName && this.contactNumber && this.email) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  goBack() {
    window.location.href = '/home';
  }

  createPartner() {
    this.partner.userAddressLine1 = this.address;
    this.partner.userPhone = this.contactNumber;
    this.partner.userNames = this.partnerName;
    this.partner.userMail = this.email;
    this.partner.userState = this.stateSelected;
    this.partner.userPostalCode = this.zipCode;
    this.partner.userCity = this.city;
    this.partnerService.savePartner(this.partner).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleSaveSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.ErrorMessage();
        this.clearFields();
      }
    );
  }

  handleSaveError(StatusCode: number) {
    this.ErrorMessage();
    this.clearFields();
  }

  async handleSaveSuccess(partner: UserDTO) {
    //console.log(partner.userId);
    if (partner.userId === 0) {
      this.alert = {
        alertMessage: 'This user already exists',
        alertType: 'alert alert-warning',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };

      this.alertService.updateAlertState(this.alert);
    } else {
      this.alert = {
        alertMessage: 'Partner saved successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(this.alert);

      this.clearFields();
      location.reload();
    }
  }
  handleGetAllStatesSuccess(states: MasterDataDTO[]) {
    this.states = states;
  }

  clearFields() {
    // this.address = '';
    // this.contactNumber = undefined;
    // this.partnerName = '';
    // this.email = '';
    // this.stateSelected = '';
    // this.zipCode = undefined;
    // this.city = '';
  }

  ErrorMessage() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    //localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);
  }

  checkEmailValidity() {
    const isValid = this.emailModel?.valid;
    if (isValid) {
      this.validMail = true;
    } else {
      this.validMail = false;
    }
    //console.log(this.validMail);
  }
}
